import { StyleSheet, css } from 'aphrodite'
import { useNavigate } from 'react-router-dom'
import InfoGrid from '../components/InfoGrid'
import LandingSection from '../components/LandingSection'
import StakeholderCardSection from '../components/StakeholderCardSection'
import LandingFooter from '../components/navigation/LandingFooter'
import LandingHeader from '../components/navigation/LandingHeader'

export default function ContactUsPage() {
  const navigate = useNavigate()

  const handleJoinCommunityClick = () => {
    window.scrollTo(0, 0)
    navigate('/register')
  }

  return (
    <div className={css(styles.container)}>
      <LandingHeader />

      <section className={css(styles.faqAndContactSection)}>
        <h1 className={css(styles.mainTitle)}>Contact Us</h1>
        <div className={css(styles.faqContent)}>
          <h2 className={css(styles.faqTitle)}>FREQUENTLY ASKED QUESTIONS</h2>
          <p className={css(styles.faqDescription)}>
            Find answers to common questions about the Ecosystem, and its
            services in the digital Dump Truck marketplace.
          </p>
          <div className={css(styles.faqList)}>
            <div className={css(styles.faqItem)}>
              <h4 className={css(styles.faqQuestion)}>
                What is the Ecosystem?
              </h4>
              <p className={css(styles.faqAnswer)}>
                The Ecosystem is a digital platform for the Dump Truck Industry,
                enabling Contractors, Brokers, Sub Hauler Corp., and Drivers to
                securely and efficiently connect and transact, reducing the
                carbon footprint.
              </p>
            </div>
            <div className={css(styles.faqItem)}>
              <h4 className={css(styles.faqQuestion)}>
                How do I get started with the Ecosystem?
              </h4>
              <p className={css(styles.faqAnswer)}>
                Simply create your account, complete your profile, and start
                connecting in a collaborative Dump Truck community.
              </p>
            </div>
            <div className={css(styles.faqItem)}>
              <h4 className={css(styles.faqQuestion)}>
                Is there support available if I need help?
              </h4>
              <p className={css(styles.faqAnswer)}>
                Yes! Our dedicated support team provides assistance 24/7. You
                can reach us via email or phone for guidance and technical
                support.
              </p>
            </div>
            <div className={css(styles.faqItem)}>
              <h4 className={css(styles.faqQuestion)}>
                What Makes the Ecosystem Different from Supply Chain and
                Logistics Management?
              </h4>
              <p className={css(styles.faqAnswer)}>
                First, the Ecosystem is the only platform dedicated to all
                stakeholders in the Dump Truck marketplace. Second, the
                Ecosystem is specifically built for the Dump Truck Industry by
                an industry expert. Finally, the Ecosystem focuses on
                Transparency, Trust, and Collaboration, helping to reduce a
                negative environmental impact while fostering sustainability.
              </p>
            </div>
          </div>
        </div>
        <div className={css(styles.contactDetailsContainer)}>
          <div className={css(styles.contactDetails)}>
            <h3 className={css(styles.contactDetailsTitle)}>
              Contact Information
            </h3>
            <div className={css(styles.contactItem)}>
              <h4 className={css(styles.contactItemTitle)}>Company</h4>
              <p className={css(styles.contactItemText)}>DayDaCo, Inc.</p>
            </div>
            <div className={css(styles.contactItem)}>
              <h4 className={css(styles.contactItemTitle)}>Address</h4>
              <p className={css(styles.contactItemText)}>
                350 Townsend Street, Suite 550
                <br />
                San Francisco, CA 94107
              </p>
            </div>
            <div className={css(styles.contactItem)}>
              <h4 className={css(styles.contactItemTitle)}>Phone</h4>
              <p className={css(styles.contactItemText)}>+1 (555) 123-4567</p>
            </div>
            <div className={css(styles.contactItem)}>
              <h4 className={css(styles.contactItemTitle)}>Email</h4>
              <p className={css(styles.contactItemText)}>
                <a
                  href="mailto:info@daydaco.com"
                  className={css(styles.emailLink)}
                >
                  info@daydaco.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className={css(styles.contactInfoSection)}>
        <div className={css(styles.contactInfoContainer)}>
          <h2 className={css(styles.contactInfoTitle)}>READY TO CONNECT?</h2>
          <p className={css(styles.contactInfoDescription)}>
            Our team is committed to providing technical support and guidance.
            Whether you are a Contractor, Broker, Sub Hauler, or Driver, the
            Ecosystem enables you to conveniently navigate the Dump Truck
            marketplace.
          </p>
        </div>
        <div className={css(styles.infoGridContainer)}>
          <InfoGrid
            icon="/icons/sharing.png"
            title="Quick Response"
            description="Get answers to your questions 24/7. Our support team is standing by to assist you."
          />
          <InfoGrid
            icon="/icons/trust_icon.png"
            title="Expert Guidance"
            description="Recommendations from an industry expert who understands your needs and challenges."
          />
          <InfoGrid
            icon="/icons/workload.png"
            title="Comprehensive Support"
            description="From onboarding to utilizing advanced tools and features, the Ecosystem provides support when you need it."
          />
          <InfoGrid
            icon="/icons/leaf.png"
            title="Collaborative Governance"
            description="The Ecosystem is not just a platform. It is a network of stakeholders who believe in trust, and in efficient and effective business operations"
          />
        </div>
      </section>

      <StakeholderCardSection backgroundColor="#F2F5F7" />

      <LandingSection
        title="START YOUR DIGITAL TRANSFORMATION"
        description="Be part of the revolution that's transforming the dump truck industry. Connect with thousands of verified operators, contractors, and haulers in our trusted digital community."
        imageSrc="/ecosystem.webp"
        imageAlt="Digital Transformation"
        buttonText="Join the Ecosystem"
        testimonialText="Trusted by 10,000+ operators,"
        userCount="contractors and haulers"
        onButtonClick={handleJoinCommunityClick}
      />

      <LandingFooter />
    </div>
  )
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
  },
  titleSection: {
    padding: '40px 1rem',
    textAlign: 'center',
    '@media (min-width: 768px)': {
      padding: '60px 2rem',
    },
    '@media (min-width: 1024px)': {
      padding: '80px 3rem',
    },
  },
  pageTitle: {
    fontFamily: '"Anton", sans-serif',
    fontSize: '48px',
    fontWeight: 400,
    color: '#1F3D61',
    lineHeight: 1.2,
    margin: 0,
    '@media (min-width: 768px)': {
      fontSize: '64px',
    },
    '@media (min-width: 1024px)': {
      fontSize: '80px',
    },
  },
  contactInfoSection: {
    padding: '40px 1rem 0 1rem',
    backgroundColor: '#F2F5F7',
    '@media (min-width: 768px)': {
      padding: '60px 2rem 0 2rem',
    },
    '@media (min-width: 1024px)': {
      padding: '80px 3rem 0 3rem',
    },
    '@media (min-width: 1280px)': {
      padding: '100px 5rem 0 5rem',
    },
  },
  contactInfoContainer: {
    textAlign: 'center',
    marginBottom: '40px',
    '@media (min-width: 768px)': {
      marginBottom: '60px',
    },
  },
  contactInfoTitle: {
    fontFamily: '"Anton", sans-serif',
    fontSize: '32px',
    fontWeight: 400,
    color: '#1F3D61',
    lineHeight: 1.2,
    marginBottom: '16px',
    '@media (min-width: 768px)': {
      fontSize: '48px',
      marginBottom: '20px',
    },
    '@media (min-width: 1024px)': {
      fontSize: '60px',
      marginBottom: '24px',
    },
  },
  contactInfoDescription: {
    fontSize: '14px',
    lineHeight: 1.5,
    color: '#4B5563',
    fontWeight: 400,
    maxWidth: '800px',
    margin: '0 auto',
    '@media (min-width: 768px)': {
      fontSize: '16px',
    },
    '@media (min-width: 1024px)': {
      fontSize: '18px',
    },
  },
  infoGridContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '20px',
    '@media (min-width: 768px)': {
      gridTemplateColumns: '1fr 1fr',
      gap: '24px',
    },
    '@media (min-width: 1024px)': {
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: '28px',
    },
  },
  mainTitle: {
    fontFamily: '"Anton", sans-serif',
    fontSize: '48px',
    fontWeight: 400,
    color: '#1F3D61',
    lineHeight: 1.2,
    margin: '0 0 40px 0',
    textAlign: 'center',
    gridColumn: '1 / -1',
    '@media (min-width: 768px)': {
      fontSize: '64px',
      marginBottom: '60px',
    },
    '@media (min-width: 1024px)': {
      fontSize: '80px',
      marginBottom: '80px',
    },
  },
  faqAndContactSection: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '32px',
    alignItems: 'flex-start',
    padding: '40px 1rem',
    '@media (min-width: 768px)': {
      gap: '40px',
      padding: '60px 2rem',
    },
    '@media (min-width: 1024px)': {
      gridTemplateColumns: '2fr 1fr',
      gap: '48px',
      padding: '80px 3rem',
    },
    '@media (min-width: 1280px)': {
      padding: '100px 5rem',
    },
  },
  sectionDivider: {
    height: '1px',
    backgroundColor: '#E5E7EB',
    width: '100%',
    gridColumn: '1 / -1',
    marginBottom: '40px',
    '@media (min-width: 768px)': {
      marginBottom: '50px',
    },
    '@media (min-width: 1024px)': {
      marginBottom: '60px',
    },
  },
  faqContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  faqTitle: {
    fontFamily: '"Anton", sans-serif',
    fontSize: '32px',
    fontWeight: 400,
    color: '#1F3D61',
    lineHeight: 1.2,
    '@media (min-width: 768px)': {
      fontSize: '48px',
    },
    '@media (min-width: 1024px)': {
      fontSize: '52px',
    },
  },
  faqDescription: {
    fontSize: '14px',
    lineHeight: 1.5,
    color: '#4B5563',
    fontWeight: 400,
    '@media (min-width: 768px)': {
      fontSize: '16px',
    },
    '@media (min-width: 1024px)': {
      fontSize: '18px',
    },
  },
  faqList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  faqItem: {
    paddingBottom: '16px',
    borderBottom: '1px solid #E5E7EB',
  },
  faqQuestion: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#1F3D61',
    marginBottom: '8px',
    '@media (min-width: 768px)': {
      fontSize: '18px',
    },
  },
  faqAnswer: {
    fontSize: '14px',
    lineHeight: 1.6,
    color: '#4B5563',
    '@media (min-width: 768px)': {
      fontSize: '15px',
    },
  },
  contactDetailsContainer: {
    display: 'flex',
    justifyContent: 'center',
    '@media (min-width: 1024px)': {
      justifyContent: 'flex-start',
    },
  },
  contactDetails: {
    backgroundColor: '#F8F9FA',
    padding: '32px',
    borderRadius: '12px',
    width: '100%',
    '@media (min-width: 1024px)': {
      maxWidth: '400px',
    },
  },
  contactDetailsTitle: {
    fontFamily: '"Anton", sans-serif',
    fontSize: '24px',
    fontWeight: 400,
    color: '#1F3D61',
    marginBottom: '24px',
    '@media (min-width: 768px)': {
      fontSize: '28px',
    },
  },
  contactItem: {
    marginBottom: '20px',
    ':last-child': {
      marginBottom: 0,
    },
  },
  contactItemTitle: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#1F3D61',
    marginBottom: '4px',
  },
  contactItemText: {
    fontSize: '14px',
    lineHeight: 1.5,
    color: '#4B5563',
    '@media (min-width: 768px)': {
      fontSize: '15px',
    },
  },
  emailLink: {
    color: '#007BFF',
    textDecoration: 'none',
    ':hover': {
      color: '#0056CC',
      textDecoration: 'underline',
    },
  },
})
